"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const trans_1 = require("@common/tsutils/trans");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
let FilterItem = class FilterItem extends vue_property_decorator_1.Vue {
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get filterHelper() {
        const helper = Object.assign({}, this.filter);
        return helper;
    }
    get typesDictionary() {
        const keys = ['starts_with', 'contains', 'not_contains', 'ends_with', 'equals', 'not_equals'];
        return keys.map((k) => {
            return {
                'value': k,
                'label': (0, trans_1.trans)(`tabular.configuration.filters.type.${k}`)
            };
        });
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], FilterItem.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], FilterItem.prototype, "filter", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], FilterItem.prototype, "columns", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], FilterItem.prototype, "removable", void 0);
FilterItem = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Select: bmk_ui_framework_1.Select, SelectField: bmk_ui_framework_1.SelectField, InputField: bmk_ui_framework_1.InputField, Trash2: lucide_vue_next_1.Trash2, Button: bmk_ui_framework_1.Button }
    })
], FilterItem);
exports.default = FilterItem;
